import React from 'react';
import PropTypes from 'prop-types';
import {Glyphicon} from 'react-bootstrap';

const UnreadMessages = ({unreadMessages, show, url}) => (show && unreadMessages > 0) && (
  <div>
    <a className="btn btn-grey my-messages-button" href={url}>
      <Glyphicon glyph="envelope"/>
      <div className="message-count">
        {unreadMessages}
      </div>
    </a>
  </div>
);

UnreadMessages.propTypes = {
  unreadMessages: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
};

export default UnreadMessages;



// WEBPACK FOOTER //
// ./src/components/user-menu/unread-messages.jsx